// extracted by mini-css-extract-plugin
export var disabledStyle = "search_jobs_result_accordion_header-module--disabledStyle--fuPDQ";
export var headingStyle = "search_jobs_result_accordion_header-module--headingStyle--wETK3";
export var innerWrapperStyle = "search_jobs_result_accordion_header-module--innerWrapperStyle--f1vn5";
export var wrapperStyle = "search_jobs_result_accordion_header-module--wrapperStyle--yi5b1";